import Axios from "./index";

export const indexChannels = () => {
  return Axios.get("/user/sendbird_channels");
};
export const createChannel = channelParams => {
  return Axios.post("/user/sendbird_channels", channelParams);
};
export const leaveChannel = channelUrl => {
  return Axios.delete(`/user/sendbird_channels/${channelUrl}`);
};
